<div class="container">
    <div>
        <div class="row" *ngIf="viewAfterLogic">
            <div class="col-5">
                <div class="bottom-15 wide">
                    <button class="button primary" [routerLink]="['/ssi/enrollment/external-agent/Step1']">External Agent Enrollment</button>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="isPhoneView">
            <div class="col-5">
                <div class="bottom-15 wide">
                    <button class="button primary" (click)="RedirectPhoneEnrollment()">Phone Enrollment</button>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="isViewPage">
            <div class="col-5">
                <div class="bottom-15 wide">
                    <button class="button primary" [routerLink]="['/ssi/enrollment/data-entry/Step1']">Data Entry Enrollment</button>
                </div>
            </div>
        </div>
    </div>
    <!--<div *ngIf="NEJEView">
        <div class="row">
            <div class="col-5">
                <div class="bottom-15 wide">
                    <button class="button primary" [routerLink]="['/enrollment/neje/phone-enrollment/Step1']">Phone Enrollment</button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-5">
                <div class="bottom-15 wide">
                    <button class="button primary" [routerLink]="['/enrollment/neje/data-entry/Step1']">Data Entry Enrollment</button>
                </div>
            </div>
        </div>
    </div>-->
</div>
